module.exports = "/images/transaction-coordinator-icon.png?25904971b6b0081bea7e1620d7bc6a92";